var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-card',{staticStyle:{"width":"500px"}},[_c('q-card-section',[_vm._t("title")],2),_c('q-separator'),_c('q-card-section',[_vm._t("message")],2),_c('q-card-actions',{staticClass:"bg-white",attrs:{"align":"right"}},[_c('q-btn',{directives:[{name:"close-popup",rawName:"v-close-popup"}],attrs:{"label":"OK","color":"primary"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }